export default __webpack_public_path__ + "static/about-forex-175a7ed9d0763fb452bb05a3f2e835d5.png";